export const curlRequest = (tenant: string, event: string): string => {
  return `
curl -X POST -H "Content-Type: application/json" -d '${event}' http://<EVENT_LISTENER_IP_ADDRESS>/transaction/v1
  `;
};

export const javaNetHttpClient = (tenant: string, event: string): string => {
  return `
String url = "<BASE_URL>/transaction/v1";

String requestBody = """
${event}
""";

HttpClient client = HttpClient.newBuilder()
  .version(HttpClient.Version.HTTP_1_1)
  .followRedirects(HttpClient.Redirect.NORMAL)
  .build();

HttpRequest request = HttpRequest.newBuilder()
  .uri(URI.create(url))
  .header("Content-Type", "application/json")
  .POST(HttpRequest.BodyPublishers.ofString(requestBody))
  .timeout(Duration.ofSeconds(3))
  .build();

HttpResponse<String> response = client.send(request, HttpResponse.BodyHandlers.ofString());
String responseBody = response.body();

System.out.println(responseBody);
  `;
};

export const apacheHttpClient = (tenant: string, event: string): string => {
  return `
String url = "<BASE_URL>/transaction/v1";

String requestBody = """
${event}
""";

CloseableHttpClient httpClient = HttpClients.custom()
  .setRedirectStrategy(new LaxRedirectStrategy())
  .build();

HttpPost request = new HttpPost();
request.setURI(URI.create(url));
request.setHeader(new BasicHeader("Content-Type", "application/json"));
request.setEntity(new StringEntity(requestBody));

CloseableHttpResponse response = httpClient.execute(request);
String responseBody = EntityUtils.toString(response.getEntity(), StandardCharsets.UTF_8);

System.out.println(responseBody);
  `;
};

export const googleHttpClient = (tenant: string, event: string): string => {
  return `
String url = "<BASE_URL>/transaction/v1";

String requestBody = """
${event}
""";

HttpRequestFactory requestFactory = new NetHttpTransport().createRequestFactory();
HttpRequest request = requestFactory.buildPostRequest(new GenericUrl(url), ByteArrayContent.fromString("application/json", requestBody));
String responseBody = request.execute().parseAsString();

System.out.println(responseBody);
  `;
};

export const okHttpClient = (tenant: string, event: string): string => {
  return `
String url = "<BASE_URL>/transaction/v1";

String requestBody = """
${event}
""";

OkHttpClient client = new OkHttpClient();

Request request = new Request.Builder()
  .url(url)
  .post(RequestBody.create(requestBody, MediaType.parse("application/json")))
  .build();

Call call = client.newCall(request);
Response response = call.execute();
String responseBody = response.body().string();

System.out.println(responseBody);
  `;
};

export const jQueryHttpClient = (tenant: string, event: string): string => {
  return `
var settings = {
"url": "BASE_URL/transaction/v1",
"method": "POST",
"timeout": 0,
"headers": {
  "Content-Type": "application/json"
},
"data": JSON.stringify(${event}),
};

$.ajax(settings).done(function (response) {
  console.log(response);
});
  `;
};

export const nodeJsAxiosHttpClient = (tenant: string, event: string): string => {
  return `
var axios = require('axios');
var data = JSON.stringify(${event});

var config = {
  method: 'post',
  url: 'BASE_URL/transaction/v1',
  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};

axios(config)
.then(function (response) {
  console.log(JSON.stringify(response.data));
})
.catch(function (error) {
  console.log(error);
});
  `;
};

export const pythonRequestHttpClient = (tenant: string, event: string): string => {
  return `
import requests
import json

url = "BASE_URL/transaction/v1"

payload = json.dumps(${event})
headers = {
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
  `;
};
